// Module
var code = "<span class=\"horses-list-box\" ng-bind-html=\"vm.horsesString\"></span> ";
// Exports
module.exports = code;